import {Label} from "../../../basic/label";
import {Select, SelectContent, SelectItem, SelectTrigger, SelectValue} from "../../../basic/select";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";

interface RoleSelectorProps {
    role: string;
    onRoleChange: (role: string) => void;
    isUniversityTeam?: boolean;
}

export function RoleSelector({role, onRoleChange, isUniversityTeam = false}: RoleSelectorProps) {
    const {t} = useTranslationWithKeys();

    return (
        <div className="space-y-2">
            <Label htmlFor="userRole">{t('admin.users.createUserDialog.role')} *</Label>
            <Select
                value={role}
                onValueChange={onRoleChange}
            >
                <SelectTrigger id="userRole">
                    <SelectValue placeholder={t('admin.users.createUserDialog.selectRole')}/>
                </SelectTrigger>
                <SelectContent>
                    <SelectItem value="Admin">{t('admin.users.roles.admin')}</SelectItem>
                    <SelectItem value="User">{t('admin.users.roles.user')}</SelectItem>
                    {isUniversityTeam && (
                        <SelectItem value="Student">{t('admin.users.roles.student')}</SelectItem>
                    )}
                </SelectContent>
            </Select>
        </div>
    );
}
